import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog, FormErrorModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { OptionModel, SurveyModel, ResultsFilters, QuestionModel, FileModel } from 'Pages/survey'
import { FileWithPreview } from 'LibNeo'

type SurveyState = {
	user: number | null
	data: ResponseCatalog<SurveyModel>
	openedItem: number | null
	needSave: boolean
	requestParams: RequestParams
	statusError: boolean | null
	formErrors: FormErrorModel | boolean | null
	results: any
	results_filters: QuestionModel[] | null
}

const initialState: SurveyState = {
	data: new ResponseCatalog<SurveyModel>(),
	openedItem: null,
	needSave: false,
	requestParams: new RequestParams(),
	user: null,
	statusError: null,
	formErrors: null,
	results: null,
	results_filters: null,
}

export namespace SurveyNS {
	export type GetSurvey = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
		errorCallback?: Callback
	}>
	export type ClearSurvey = PayloadAction
	export type SetParams = PayloadAction<RequestParams>
	export type NeedSave = PayloadAction<boolean>
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<ResponseCatalog<SurveyModel>>
	export type CreateOne = PayloadAction<{
		data: SurveyModel
		callback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		id: number
		data: SurveyModel
		callback?: Callback
	}>
	export type CreateOnes = PayloadAction<{
		survey_id: number
		question_id: number
		datalist: OptionModel[]
		callback?: Callback
	}>
	export type DeleteOne = PayloadAction<{ id: number; callback?: Callback }>
	export type DownloadSurveyResults = PayloadAction<{
		id: number
		params: ResultsFilters
		callback?: Callback
	}>
	export type ShowSurveyResults = PayloadAction<{
		id: number
		filters: ResultsFilters
		callback?: Callback
	}>
	export type SetSurveyResult = PayloadAction<any>
	export type SetSurveyResultFilters = PayloadAction<QuestionModel[] | null>
	export type SetSurveyFormError = PayloadAction<FormErrorModel | boolean>
	export type UploadSurveyFile = PayloadAction<{
		id: number
		file: FileWithPreview | FileWithPreview[]
		callback?: Callback
		errorCallback?: Callback
	}>
	export type DeleteSurveyFile = PayloadAction<{
		file: FileModel
		callback?: Callback
	}>
	export type UpdateSurveyFile = PayloadAction<{
		deleteFile: FileModel
		id: number
		file: FileWithPreview | FileWithPreview[]
		callback?: Callback
		errorCallback?: Callback
	}>
}

export const surveySlice = createSlice({
	name: 'survey',
	initialState,
	reducers: {
		getSurvey: (state, action: SurveyNS.GetSurvey) => {
			// @ts-ignore
			state.user = action.payload
		},
		clearSurvey: (state, action: SurveyNS.ClearSurvey) => {
			state.data = new ResponseCatalog<SurveyModel>()
			state.requestParams = new RequestParams()
		},
		setParams: (state, action: SurveyNS.SetParams) => {
			state.requestParams = action.payload
		},
		needSave: (state, action: SurveyNS.NeedSave) => {
			state.needSave = action.payload
		},
		getOne: (state, action: SurveyNS.GetOne) => {},
		setOne: (state, action: SurveyNS.SetOne) => {
			state.data = action.payload
		},
		createOne: (state, action: SurveyNS.CreateOne) => {},
		updateOne: (state, action: SurveyNS.UpdateOne) => {
			state.formErrors = null
		},
		deleteOne: (state, action: SurveyNS.DeleteOne) => {},
		downloadSurveyResults: (state, action: SurveyNS.DownloadSurveyResults) => {},
		showSurveyResults: (state, action: SurveyNS.ShowSurveyResults) => {},
		setSurveyResult: (state, action: SurveyNS.SetSurveyResult) => {
			state.results = action.payload
		},
		setSurveyResultsFilters: (state, action: SurveyNS.SetSurveyResultFilters) => {
			state.results_filters = action.payload
		},
		setSurveyFormError: (state, action: SurveyNS.SetSurveyFormError) => {
			state.formErrors = action.payload
		},
		uploadSurveyFile: (state, action: SurveyNS.UploadSurveyFile) => {},
		deleteSurveyFile: (state, action: SurveyNS.DeleteSurveyFile) => {},
		updateSurveyFile: (state, action: SurveyNS.UpdateSurveyFile) => {},
	},
})
